module.exports = __webpack_public_path__ + "static/img/4762_phase_function_Paper_Points.c412ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4762_phase_function_Paper_Points.png
// module id = xuXt
// module chunks = 0